package one.healthium.onboarding.data

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.locale.LocaleProvider
import one.healthium.onboarding.domain.OnboardingModel
import one.healthium.onboarding.domain.OnboardingRepository
import one.primehealth.app.BaseAppResourceProvider

internal class AppOnboardingRepository(
    private val json: Json,
    private val conditionalScreensFilter: ConditionalScreensFilter,
    private val appResourceProvider: BaseAppResourceProvider,
    private val localeProvider: LocaleProvider,
) : OnboardingRepository {
    override suspend fun get(): OnboardingModel {
        return withContext(Dispatchers.IO) {
            val onboardingFileId = DEFAULT_ONBOARDING_ID
            val bytes = appResourceProvider.readBytes("files/onboarding/${localeProvider.getLocale()}/onboarding_${onboardingFileId}.json")
            val model = json.decodeFromString<OnboardingModel>(bytes.decodeToString())
            model.copy(screens = conditionalScreensFilter.filter(model.screens))
        }
    }

    private companion object {
        const val DEFAULT_ONBOARDING_ID = "v2000"
    }
}
